export default "__VITE_ASSET__BK2B9kbK__"